module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/faq-hero-desktop-2024-28654d1ab7197e21b37afac680312741.webp";